module.exports = __webpack_public_path__ + "img/youtube.57c75406.png";